<template>
    <Header />
    <div class="container">
        <router-view />
    </div>
    <Footer />
    <transition name="fade">
        <div class="app-cover" ref="cover" v-if="is_show_cover">
            <video v-if="is_video" autoplay muted webkit-playsinline playsinline ref="video">
                <source :src="video_url" type="video/mp4">
            </video>
            <img :src="image_url"  v-else>

        </div>
    </transition>

</template>
<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
    components: {
        Header,
        Footer,
    },

    data() {
        return {
            is_show_cover: true,
            is_video: false,
            image_url: '',
            video_url: '',
        };
    },

    watch: {
        '$route.params': {
            handler(params) {
                this.updateClass(params);
            },

            immediate: true,
        },
    },

    methods: {
        updateClass(params) {
            let body_class = '';
            if (this.$route.name !== 'home') body_class = 'not-home ';
            if (typeof this.$route.name === 'string') body_class = body_class + 'page-' + this.$route.name;
            if (params.slug) body_class = body_class + ' slug-' + params.slug;
            if (params.category) body_class = body_class + ' category-' + params.category;
            document.documentElement.classList.remove('disabled-scroll');

            document.body.className = body_class;
            this.$store.state.show_menus = false;

            if (this.$store.state.disabled_scroll) {
                this.$store.state.disabled_scroll = false;
            } else {
                window.scrollTo(0, 0);
            }

        },
    },


    mounted() {
        this.$store.state.site_name = window.globals.name;
        this.$store.state.site_description = window.globals.description;

        this.$ajax.get('/splash-screen').then((res) => {
            const random = Math.floor(Math.random() * res.data.length);
            const item = res.data[random];

            this.is_video = item.mime_type.includes('video/');
            
            if (this.is_video) {
                this.video_url = item.url;
                this.$nextTick(() => {
                    if (this.$refs.video) this.$refs.video.addEventListener('ended', () => {
                        this.is_show_cover = false;
                    });
                });
            } else {
                this.image_url = item.url;
                
                setTimeout(() => {
                    this.is_show_cover = false;
                }, 5000);
            }

        });

        // this.video_url = window.globals.cover_video;
        // this.$nextTick(() => {

        //     if (this.$refs.video) this.$refs.video.addEventListener('ended', () => {
        //         this.is_show_cover = false;
        //     });
        // });
    },
}
</script>

<style lang="scss">
@import "@/assets/sass/fonts";
@import "@/assets/sass/reset";

/********* Base */
$padding: 1.2rem;

// remove scroll bar
::-webkit-scrollbar {
    display: none;
}

:root {
    --inner-width: 1680px;
    --content-width: 80rem;
    --base-size: 2.2rem;
    --medium-size: 2.8rem;
    --large-size: 3rem;
    --small-size: 2rem;
    --extra-small-size: 1rem;
    --menu-size: 1.5rem;
    --title-size: 4.2rem;
    --big-size: 4.2rem;
    --letter-spacing: 0rem;
    // --big-size: 3rem;
    // --large-size: 4rem;

    --padding-25: #{$padding / 4};
    --padding-50: #{$padding / 2};
    --padding: #{$padding};
    --padding-x2: #{$padding * 2};
    --padding-x3: #{$padding * 3};
    --padding-x4: #{$padding * 4};
    --padding-x5: #{$padding * 5};
    --padding-x6: #{$padding * 6};
    --padding-x7: #{$padding * 7};
    --padding-x8: #{$padding * 8};
    --padding-x9: #{$padding * 9};
    --padding-x10: #{$padding * 10};
    --padding-x18: #{$padding * 18};
    --padding-x30: #{$padding * 30};

    --padding-50-neg: -#{$padding / 2};
    --padding-neg: -#{$padding};
    --padding-neg-x2: -#{$padding * 2};
    --padding-neg-x3: -#{$padding * 3};

    // --padding-x5: #{$padding * 5};
    // --padding-x6: #{$padding * 6};

    --font: "ABC ROM", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    --font2: "Martina Plantijn", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    --font-color: #000000;
    --bg-color: #FFFFFF;
    --gray: #808080;

    --blue: #DFEBF0;
    --green: #CBD3D0;
    --red: #FF4100;
    --yellow: #CBA85F;


    // --purple: #C06BE8;
}

// @media only screen and (max-width: 800px) {
//     $padding: 2rem;
// }

input,
text,
keygen,
select,
button,
meter,
progress,
pre {
    font-family: var(--font);
}

/********* Links */
// :focus {
//     outline: 3px dashed var(--font-color);
// }

a,
a:visited,
a:active {
    color: var(--font-color);
    // outline: none;
    text-decoration: none;
    transition: color .2s;
}

*[tabindex="0"],
a:focus {
    // outline-width: 3px;
    // outline-style: dashed;
    outline-color: black;
}

a:hover {
    text-decoration: none;
    color: var(--gray);
}

// input:-webkit-autofill {
//     box-shadow: 0 0 0px 1000px white inset;
// }

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

h1,
h2,
h3,
h4,
h5,
h6,
strong,
span,
b,
figcaption,
p {
    font-weight: 300;
    font-variant-numeric: normal;
    font-variant-numeric: lining-nums;
}

i,
em {
    font-style: italic;
    font-family: var(--font);
    font-variant-numeric: normal;
    font-variant-numeric: lining-nums;
}

input,
textarea,
select,
button {
    font-family: var(--font);
    font-variant-numeric: normal;
    font-variant-numeric: lining-nums;
    font-weight: 300;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    bottom: 0;
    color: transparent;
    cursor: pointer;
    height: auto;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
}

::-webkit-input-placeholder {
    color: var(--gray);
}

::-moz-placeholder {
    color: var(--gray);
}

:-ms-input-placeholder {
    color: var(--gray);
}

:-moz-placeholder {
    color: var(--gray);
}

::-moz-selection {
    background: var(--gray);
    text-shadow: none;
    color: white;
}

::selection {
    background: var(--gray);
    text-shadow: none;
    color: white;
}

.mobile-item {
    display: none;
}

.desktop-item {
    display: block;
}

html {
    -webkit-overflow-scrolling: touch;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    font-size: 10px;
    overflow: overlay;
    text-rendering: optimizelegibility;
    background-color: var(--bg-color);

    &.disabled-scroll {
        overflow: hidden !important;
    }

    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    &::-webkit-scrollbar-track {
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        border: 2px solid transparent;
        background-clip: content-box;
        background-color: transparent;
        transition: .2s background-color ease;
    }

    &:hover::-webkit-scrollbar-thumb {
        background-color: rgba(#000, .35);
    }

}

html body {
    font-family: var(--font);
    color: var(--font-color);
    background-color: var(--bg-color);
    font-feature-settings: 'ss02';

    /* Font smoothing */
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: var(--base-size);
    min-height: 100vh;
    line-height: 1.35;
    font-weight: 300;
}

// Syntax for old style tabular numbers 
p {
    font-variant-numeric: lining-nums;
}

em {
    font-style: italic;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.wrap {
    min-height: 100vh;
    display: grid;
    grid-template-rows: auto 1fr auto;
    grid-template-columns: 100%;
}

.inner {
    width: auto;
    max-width: var(--inner-width);
    margin-left: auto;
    margin-right: auto;
    padding-left: var(--padding-x2);
    padding-right: var(--padding-x2);

    @media screen and (max-width: 768px) {
        padding-left: var(--padding);
        padding-right: var(--padding);
    }
}

.cols {
    display: flex;
    flex-wrap: wrap;

    &>* {
        padding-left: var(--padding);
        padding-right: var(--padding);
        box-sizing: border-box;
    }

    &-2 {
        &>* {
            width: 50%;
        }
    }

    &-3 {
        &>* {
            width: 33.33%;
        }
    }

    &-4 {
        &>* {
            width: 25%;
        }
    }

    &-5 {
        &>* {
            width: 20%;
        }
    }

    &-6 {
        &>* {
            width: 16.66%;
        }
    }
}

.app-cover {
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 999999;
    background: var(--blue);
    display: none;

    img,
    video {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 9;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.img-wrap {
    position: relative;
    width: 100%;
    background-color: var(--blue);

    &::before {
        display: block;
        content: '';
    }

    img {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        object-fit: cover;
    }

    &.r-3x4 {
        &::before {
            padding-bottom: 75%;
        }
    }

    &.r-4x3 {
        &::before {
            padding-bottom: 150%;
        }
    }

    &.r-1x1 {
        &::before {
            padding-bottom: 100%;
        }
    }
}

.order-move,
.order-enter-active,
.order-leave-active {
    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.order-enter-from,
.order-leave-to {
    opacity: 0;
    transform: scaleY(0.01) translate(30px, 0);
}

.order-leave-active {
    position: absolute;
}

@media only screen and (max-width: 1728px) {
    html {
        font-size: .575vw;
    }
}

// @media only screen and (max-width: 1600px) {
//     html {
//         font-size: .625vw;
//     }
// }

@media only screen and (max-width: 780px) {
    $padding: 2rem;

    :root {
        --inner-width: auto;
        --content-width: auto;
        --base-size: 2.2rem;
        --medium-size: 2.4rem;
        --large-size: 2.8rem;
        --small-size: 1.8rem;
        --extra-small-size: 1.4rem;
        --title-size: 3rem;
        --big-size: 4.3rem;
        --letter-spacing: 0rem;
        // --big-size: 3rem;
        // --large-size: 4rem;

        --padding-25: #{$padding / 4};
        --padding-50: #{$padding / 2};
        --padding: #{$padding};
        --padding-x2: #{$padding * 2};
        --padding-x3: #{$padding * 3};
        --padding-x4: #{$padding * 4};
        --padding-x5: #{$padding * 5};
        --padding-x6: #{$padding * 6};
        --padding-x7: #{$padding * 7};
        --padding-x8: #{$padding * 8};
        --padding-x9: #{$padding * 9};
        --padding-x10: #{$padding * 10};
        --padding-x18: #{$padding * 18};

        --padding-50-neg: -#{$padding / 2};
        --padding-neg: -#{$padding};
        --padding-neg-x2: -#{$padding * 2};
        --padding-neg-x3: -#{$padding * 3};
    }

    html {
        font-size: 2vw;
    }

    .cols {
        margin-left: var(--padding-50-neg);
        margin-right: var(--padding-50-neg);

        &>* {
            padding-left: var(--padding-50);
            padding-right: var(--padding-50);
            box-sizing: border-box;
        }

        &-2 {
            &>* {
                width: 100%;
            }
        }

        &-3 {
            &>* {
                width: 100%;
            }
        }

        &-4 {
            &>* {
                width: 50%;
            }
        }

        &-5 {
            &>* {
                width: 50%;
            }
        }

        &-6 {
            &>* {
                width: 50%;
            }
        }
    }
}
</style>
